/**
 * Centralized API service layer
 * Provides consistent fetch configuration and API endpoints
 */

const API_BASE_URL = process.env.REACT_APP_MEASURIT_API_BASE_URL;

/**
 * Base fetch configuration for all API calls
 */
const defaultFetchConfig = {
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
  },
  redirect: "follow",
  referrerPolicy: "no-referrer",
};

/**
 * Generic fetch wrapper with error handling
 * @param {string} url - The endpoint URL
 * @param {object} options - Fetch options
 * @returns {Promise<any>} - Parsed JSON response
 */
const fetchWithConfig = async (url, options = {}) => {
  const config = {
    ...defaultFetchConfig,
    ...options,
    headers: {
      ...defaultFetchConfig.headers,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

/**
 * Measur.it Estimates API endpoints
 */
export const estimatesApi = {
  /**
   * Upload an image to S3
   * @param {string} image - Base64 encoded image
   */
  uploadImage: (image) =>
    fetchWithConfig(`${API_BASE_URL}/estimates/upload`, {
      method: "POST",
      body: JSON.stringify({ image }),
    }),

  /**
   * Upload AI dataset with measurement metadata
   * @param {object} data - Dataset object containing measurement data
   */
  uploadDataset: (data) =>
    fetchWithConfig(`${API_BASE_URL}/estimates/datasets`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
};
